import { c as _c } from "react/compiler-runtime";
import { Button, Tooltip } from '@mantine/core';
import { HiMinusCircle, HiOutlineMinusCircle, HiOutlinePlusCircle, HiPlusCircle } from 'react-icons/hi';
import { colors } from 'components/theme/theme';
import { match, P } from 'ts-pattern';
import { IconContext } from 'react-icons/lib';
import { clamp } from 'remeda';
import { tourTipProps } from 'components/portal/tourTypes';
export type VoteButtonsProps = Pick<VoteButtonProps, 'disabledReason' | 'onChange'> & {
  value?: number;
  total?: number;
};
export const VoteButtons = t0 => {
  const $ = _c(8);
  let props;
  let total;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      total,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = total;
    $[3] = value;
  } else {
    props = $[1];
    total = $[2];
    value = $[3];
  }
  let t1;
  if ($[4] !== props || $[5] !== total || $[6] !== value) {
    t1 = value == null || total == null ? <></> : <div className="flex items-center "><VoteButton mode="down" {...{
        value,
        ...props
      }} /><b>{total}</b><VoteButton mode="up" {...{
        value,
        ...props
      }} /></div>;
    $[4] = props;
    $[5] = total;
    $[6] = value;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};
export type VoteButtonProps = {
  mode: 'down' | 'up';
  /** your vote */
  value: number;
  disabledReason?: string;
  onChange?: (v: number) => void;
};
const VoteButton = t0 => {
  const $ = _c(43);
  const {
    value,
    mode,
    disabledReason: rawDisabledReason,
    onChange
  } = t0;
  let t1;
  if ($[0] !== mode || $[1] !== rawDisabledReason || $[2] !== value) {
    t1 = rawDisabledReason ?? match(mode).with("down", () => value <= -2 ? "maximum down-votes" : undefined).otherwise(() => value >= 2 ? "maximum up-votes" : undefined);
    $[0] = mode;
    $[1] = rawDisabledReason;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const disabledReason = t1;
  let t2;
  if ($[4] !== mode || $[5] !== value) {
    t2 = match({
      mode,
      value
    }).with({
      mode: "down",
      value: P.when(_temp)
    }, _temp2).with({
      mode: "up",
      value: P.when(_temp3)
    }, _temp4).otherwise(_temp5);
    $[4] = mode;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = {
      size: "1.3rem",
      ...t2
    };
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const iconProps = t3;
  let t4;
  if ($[9] !== value) {
    t4 = value == 0 ? <span className="opacity-60">No vote made</span> : <span>Your vote:{" "}<b>{value > 0 ? "+" : ""}{value}</b></span>;
    $[9] = value;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const voteElement = t4;
  const t5 = mode == "down" ? "-1 from the vote" : "+1 to the vote";
  let t6;
  if ($[11] !== t5) {
    t6 = <span>Click to <b>{t5}</b> on this sub-question</span>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const actionElement = t6;
  const t7 = disabledReason ?? actionElement;
  let t8;
  if ($[13] !== t7) {
    t8 = <span>{t7}</span>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8 || $[16] !== voteElement) {
    t9 = <div className="flex flex-col gap-2">{voteElement}{t8}</div>;
    $[15] = t8;
    $[16] = voteElement;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = tourTipProps("subq-voting");
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = !!disabledReason;
  let t12;
  if ($[19] !== mode || $[20] !== onChange || $[21] !== value) {
    t12 = e => {
      e.stopPropagation();
      onChange?.(clamp(value + (mode == "up" ? 1 : -1), {
        min: -2,
        max: 2
      }));
    };
    $[19] = mode;
    $[20] = onChange;
    $[21] = value;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = disabledReason ? "none" : undefined;
  let t14;
  if ($[23] !== t13) {
    t14 = {
      padding: "0 0.2rem",
      height: "2.2rem",
      opacity: 1,
      background: t13
    };
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== mode || $[26] !== value) {
    t15 = mode == "down" && match(value).with(-2, _temp6).with(-1, _temp7).otherwise(_temp8);
    $[25] = mode;
    $[26] = value;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== mode || $[29] !== value) {
    t16 = mode == "up" && match(value).with(2, _temp9).with(1, _temp10).otherwise(_temp11);
    $[28] = mode;
    $[29] = value;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== iconProps || $[32] !== t15 || $[33] !== t16) {
    t17 = <IconContext.Provider value={iconProps}>{t15}{t16}</IconContext.Provider>;
    $[31] = iconProps;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t11 || $[36] !== t12 || $[37] !== t14 || $[38] !== t17) {
    t18 = <div className="flex flex-col justify-center" {...t10}><Button disabled={t11} onClick={t12} style={t14}>{t17}</Button></div>;
    $[35] = t11;
    $[36] = t12;
    $[37] = t14;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t18 || $[41] !== t9) {
    t19 = <Tooltip label={t9}>{t18}</Tooltip>;
    $[40] = t18;
    $[41] = t9;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  return t19;
};
function _temp(v) {
  return v < 0;
}
function _temp2() {
  return {
    color: colors.red[6]
  };
}
function _temp3(v_0) {
  return v_0 > 0;
}
function _temp4() {
  return {
    color: colors.green[6]
  };
}
function _temp5() {
  return {
    className: "opacity-20"
  };
}
function _temp6() {
  return <HiMinusCircle />;
}
function _temp7() {
  return <HiOutlineMinusCircle />;
}
function _temp8() {
  return <HiOutlineMinusCircle />;
}
function _temp9() {
  return <HiPlusCircle />;
}
function _temp10() {
  return <HiOutlinePlusCircle />;
}
function _temp11() {
  return <HiOutlinePlusCircle />;
}